import React, { Component } from 'react';
/* eslint-disable */
import axios from 'axios';
import { MY_API_URL } from '../../../Apanel/QueryMe';
import Alert from '../../../../shared/components/Alert';
import { Table } from 'react-bootstrap';
import { Card, CardBody, Col, Modal, Badge } from 'reactstrap';
var dateFormat = require('dateformat');
var download = require('downloadjs');
import swal from 'sweetalert';
const apiurl = MY_API_URL;
const initialstate = {
	questions: [],
	questionIndex: 0,
	result: [],
	currentDuration: 0,
	testTakers: [],
	helper: [],
	allquesids: [],
	quids: [],
	showAlert: false,
	alertType: '',
	alertText: '',
	email: '',
	token: localStorage.token,
	currentcolor: [
		'#531CB3',
		'#7149EE',
		'#B754FF',
		'#ED4FEF',
		'#ED49AB',
		'#ED4FEF',
		'#B754FF',
		'#7149EE',
	],
	content_add: '',
	stestname: '',
	myItems: [],
	testEmails: [],
	isalready: false,
};
class CustomSavedTest extends Component {
	constructor(props) {
		super(props);
		this.handleFocus = this.handleFocus.bind(this);
		this.handleChange = this.handleChange.bind(this);

		this.handleClick = this.handleClick.bind(this);
		this.lastId = -1;
	}
	state = { ...initialstate };
	componentDidMount() {
		if (localStorage.profile_completed === '0') {
			localStorage.setItem('came_from', 'customsavedtest');
			this.props.history.push({
				pathname: '/profile',
				backTo: '/',
			});
		} else {
			this.fetchcustomSavedTests();
			this.fetchTestTakers();
		}
	}
	handleFocus(event) {
		this.setState({ content_add: '' });
	}
	handleChange = (event) => {
		const { name, value } = event.target;
		console.log(name + ' ' + value);
		this.setState({ [name]: value });
		const usr_input = event.target.value;
		console.log(usr_input);
		this.setState({ content_add: usr_input });
	};

	handleAddEmail(event) {
		event.preventDefault();
		console.log(this.state.content_add);
		var newArray = this.state.myItems;
		var testEmails = this.state.testEmails;
		var currentcontent = this.state.content_add.trim();
		if (!currentcontent) {
			return;
		}
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};
		var postData = {
			testemail: currentcontent,
			testid: this.state.selectedId,
		};
		const testidurl = apiurl + 'custchecktester';
		axios
			.post(testidurl, postData, {
				headers: headers,
			})
			.then(async (response) => {
				console.log(response);
				if (response.data.data[1].length >= 1) {
					var areusers = response.data.data[1].toString();
					console.log(areusers);
					swal('Already Sent ' + areusers, {
						icon: 'error',
					});
				}
				if (response.data.data[0].length >= 1) {
					const allemails = response.data.data[0];
					let isexist = [];
					await Promise.all(
						allemails.map((temails, index) => {
							return new Promise((resolve, reject) => {
								this.state.myItems.filter((listitem) => {
									if (listitem.content == temails) {
										isexist.push(temails);
									}
								});
								// console.log('isexist ', isexist.length);

								if (isexist.length >= 1) {
									resolve('');
								} else {
									newArray.push({
										content: temails,
										id: ++this.lastId,
									});
									testEmails.push(temails);
									this.setState(
										{
											myItems: newArray,
											content_add: '',
										},
										() => {
											console.log(this.state.myItems);
											resolve('');
										},
									);
								}
							});
						}),
					);
					if (isexist.length >= 1) {
						isexist = isexist.toString();
						swal(isexist + ' Already Added', {
							icon: 'error',
						});
					}
				}
			});
	}
	handleClick(event) {
		const idToRemove = Number(event.target.dataset['item']);
		const emailToRemove = event.target.dataset['email'];
		const newArray = this.state.myItems.filter((listitem) => {
			return listitem.id !== idToRemove;
		});
		const testEmails = this.state.testEmails.filter((elistitem) => {
			return elistitem !== emailToRemove;
		});
		this.setState({ myItems: newArray, testEmails: testEmails }, () => {
			console.log('items ', this.state.myItems);
			console.log('emails ', this.state.testEmails);
		});
	}
	makeAddedList() {
		const elements = this.state.myItems.map((listitem, index) => (
			<span
				className="emaillist"
				key={listitem.id}
				onClick={this.handleClick}
				data-item={listitem.id}
				data-email={listitem.content}
				style={{
					backgroundColor: this.state.currentcolor[
						index % this.state.currentcolor.length
					],
					width: 'auto',
				}}
			>
				{listitem.content}
			</span>
		));
		return elements;
	}

	handleSendTest = (event) => {
		event.preventDefault();
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};

		const addkeyurl = apiurl + 'sendcustomTestToEmail';
		var postData = {
			email: this.state.testEmails,
			testid: this.state.selectedId,
			fromby: localStorage.viewrecruiter,
			quids: this.state.quids,
		};
		axios
			.post(addkeyurl, postData, {
				headers: headers,
			})
			.then((response) => {
				console.log(response.data.message);
				if (response.data.error) {
					this.setState({
						showAlert: true,
						alertType: 'warning',
						alertText: response.data.message,
					});
				} else {
					this.setState(
						{
							showEbox: false,
							showAlert: false,
						},
						() => {
							const headers = {
								'Content-Type': 'application/json',
								Authorization: localStorage.token,
							};
							var rname = localStorage.name;
							if (localStorage.domain) {
								rname + ' - ' + localStorage.domain;
							}
							var postData = {
								email: [this.state.testEmails],
								id: this.state.stestname,
								by: localStorage.viewrecruiter,
								rname: rname,
								tname: 'User',
							};
							const sendTestMailx = apiurl + 'sendCustomTestMail';

							axios
								.post(sendTestMailx, postData, {
									headers: headers,
								})

								.then(() => {
									swal(
										' Test ' +
											this.state.stestname +
											' ' +
											response.data.message,
										{
											icon: 'success',
										},
									);
									this.props.history.push({
										pathname: '/recruiter/customsenttest',
									});
								})
								.catch((error) => {
									console.log('Error in promise ', error);
								});
						},
					);
				}
			})
			.catch((error) => {
				console.log('Error is ', error);
				this.setState({
					alertType: 'danger',
					showAlert: true,
					alertText: 'Failed Try Again Later!',
				});
			});
	};
	handleCkey = () => {
		this.setState({
			showEbox: false,
		});
	};

	fetchTestTakers = () => {
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};

		const addkeyurl = apiurl + 'fetchTestTakers';
		var postData = {
			email: localStorage.viewrecruiter,
		};
		axios
			.post(addkeyurl, postData, {
				headers: headers,
			})
			.then((response) => {
				this.setState({
					testTakers: [...response.data.data],
				});
			});
	};
	fetchcustomSavedTests = () => {
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};

		const addkeyurl = apiurl + 'fetchcustomSavedTests';
		var postData = {
			email: localStorage.viewrecruiter,
		};
		axios
			.post(addkeyurl, postData, {
				headers: headers,
			})
			.then((response) => {
				console.log(response.data.data);
				this.setState({
					tests: [...response.data.data],
				});
			})
			.catch((error) => {
				console.log(error);
			});
	};
	getBadgeColor = (index) => {
		switch (index % 3) {
			case 0:
				return 'badge-purple';
			case 1:
				return 'badge-yellow';
			case 2:
				return 'badge-grey';
		}
	};
	viewCustomTest = (testid, n) => {
		console.log(testid);
		localStorage.setItem('viewcustestid', testid);
		this.props.history.push('/recruiter/viewcustomtest');
	};
	handleCtest = (testid, n) => {
		console.log(testid);
		localStorage.setItem('custestid', testid);
		this.props.history.push('/recruiter/addcustomtest');
	};
	render() {
		const { email, showEbox, showAlert, alertType, alertText } = this.state;
		return (
			<Col md={12}>
				<Card>
					<CardBody>
						<div className="card__title">
							<h5 className="bold-text">List of Created and Saved Tests</h5>
						</div>
						<Table striped bordered hover>
							<thead>
								<tr>
									<th>#</th>
									<th>Date</th>
									<th>Test Name</th>
									<th>No. Q</th>
									<th>Send Test</th>
									<th>Edit Test</th>
									<th>View Test</th>
								</tr>
							</thead>
							<tbody>
								{this.state.tests &&
									this.state.testTakers.length > 0 &&
									this.state.tests.map((test, index) => {
										return (
											<tr key={index}>
												<td>{index}</td>
												<td>{dateFormat(test.posted, 'd-m-yyyy')}</td>
												<td>{test.testname}</td>

												<td>{test.allq}</td>

												<td>
													<div
														className="btn btn-primary btn-sm"
														style={{ cursor: 'pointer' }}
														onClick={() => {
															this.setState({
																showEbox: true,
																selectedId: test.testid,
																stestname: test.testname,
																quids: test.qids,
																myItems: [],
																testEmails: [],
															});
														}}
													>
														Send Test
													</div>
												</td>
												<td>
													<div
														className="btn btn-primary btn-sm"
														style={{ cursor: 'pointer' }}
														onClick={this.handleCtest.bind(this, test.testid)}
													>
														Edit Test
													</div>
												</td>
												<td>
													<div
														className="btn btn-primary btn-sm"
														style={{ cursor: 'pointer' }}
														onClick={this.viewCustomTest.bind(
															this,
															test.testid,
														)}
													>
														View Test
													</div>
												</td>
											</tr>
										);
									})}
							</tbody>
						</Table>
						<Modal
							isOpen={this.state.showEbox}
							modalClassName="ltr-support"
							className="modal-dialog--primary"
						>
							<div className="modal__header">
								<button
									className="lnr lnr-cross modal__close-btn"
									type="button"
									onClick={this.handleCkey}
								/>
								<h4 className="text-modal  modal__title">
									Send : {this.state.testname}
								</h4>
							</div>
							<div className="modal__body">
								{this.state.showAlert ? (
									<Alert color={this.state.alertType}>
										<p>{this.state.alertText}</p>
									</Alert>
								) : null}
								<form
									className="form"
									onSubmit={(event) => this.handleAddEmail(event)}
								>
									{this.state.showAlert ? (
										<Alert color={this.state.alertType}>
											<p>{this.state.alertText}</p>
										</Alert>
									) : null}
									<div className="form__form-group">
										{/* <span className="form__form-group-label">
													Add Email ID
												</span> */}
										<div className="form__form-group-field">
											<textarea
												name="email"
												type="email"
												placeholder="Add Email ID"
												onFocus={this.handleFocus}
												onChange={this.handleChange}
												value={this.state.content_add}
												style={{ width: '300px' }}
											/>
											<button className="btn btn-primary btn-sm" type="submit">
												+
											</button>
										</div>
										<p>{this.makeAddedList()}</p>
									</div>
								</form>
								<form
									className="form"
									onSubmit={(event) => this.handleSendTest(event)}
								>
									{this.state.testEmails.length > 0 ? (
										<button
											className="btn btn-primary account__btn account__btn--small"
											type="submit"
										>
											Send Test
										</button>
									) : (
										<button
											className="btn btn-primary account__btn account__btn--small"
											type="button"
											desabled="true"
										>
											Send Test
										</button>
									)}
								</form>
							</div>
						</Modal>
					</CardBody>
				</Card>
			</Col>
		);
	}
}

export default CustomSavedTest;
